import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JobAction } from 'modules/jobManager/types';

export const initialJobCreationTakeoverState = false;

export const jobCreationReducer = (state = initialJobCreationTakeoverState, action?: JobAction) => {
  switch (action?.type) {
    case ActionTypes.SET_TAKEOVER_STATE: {
      return action?.payload ?? state;
    }

    default:
      return state;
  }
};
